'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardModule = function (_Resource) {
    (0, _inherits3.default)(DashboardModule, _Resource);

    function DashboardModule() {
        (0, _classCallCheck3.default)(this, DashboardModule);
        return (0, _possibleConstructorReturn3.default)(this, (DashboardModule.__proto__ || (0, _getPrototypeOf2.default)(DashboardModule)).apply(this, arguments));
    }

    (0, _createClass3.default)(DashboardModule, [{
        key: 'getForOrganization',


        /**
         * @api {get} /v1/organizations/:organization_id/dashboard_modules/:module_id getForOrganization
         * @apiGroup DashboardModule
         * @apiName getForOrganization
         * @apiDescription Get information about dashboard module.
         * @apiParam {Number} organization_id
         * @apiParam {String} [module_id='activity']
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.dashboardModule.getForOrganization({...})
         */
        value: function getForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/dashboard_modules/' + (params.module_id ? params.module_id : 'activity') + query);
        }

        /**
         * @api {get} /v1/dashboard_modules/:module_id get
         * @apiGroup DashboardModule
         * @apiName get
         * @apiDescription Get information about dashboard module.
         * @apiParam {String} [module_id='activity']
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.dashboardModule.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/dashboard_modules/' + (params && params.module_id ? params.module_id : 'activity') + query);
        }
    }]);
    return DashboardModule;
}(_resource2.default);

exports.default = DashboardModule;
//# sourceMappingURL=index.js.map